import { StandardComp } from "../atoms/standardComp"
import { icon } from "../functions/icons"
import { HorizontalLayout } from "./layout"
import { useState, useEffect, useRef, forwardRef } from "react"

export const Modal = forwardRef(function Modal({content,visible, size = "small", dismissable, position, children, hidden=true , height= 500, transparent=false},ref) {

    const [shouldRender, setShouldRender] = useState(visible);
    const [isClosing, setIsClosing] = useState(false);
    const mouseDownOnBackground = useRef(false);

    useEffect(() => {
        if (visible) {
            setShouldRender(true);
            setIsClosing(false);
            document.body.style.overflow = "hidden";
        } else if (shouldRender) {
            setIsClosing(true);
            document.body.style.overflow = "";
            setTimeout(() => {
                setIsClosing(false);
                setShouldRender(false);
            }, 255);
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [visible]);
    
    const handleMouseDown = (e) => {
        if (e.target.classList.contains("modal-background")) {
            mouseDownOnBackground.current = true;
        } else {
            mouseDownOnBackground.current = false;
        }
    };
    const handleClick = (e) => {
        if (
            dismissable &&
            mouseDownOnBackground.current &&
            e.target.classList.contains("modal-background")
        ) {
            dismissable();
        }
        mouseDownOnBackground.current = false;
    };

    if (shouldRender) {
        return(
            <div data-testid={'modal-1'} ref={ref} className={`modal-background ${isClosing ? "modal-closing" : ""} ${transparent ? "transparent" : ""}`} onClick={handleClick}  onMouseDown={handleMouseDown}>
                <div onClick={(e) => e.stopPropagation()} style={{left:position?.x-position?.width+40, top:position?.y-15, width:position?.width, height, position:position?.x && "absolute"}} className={`phone-modal modal-content modal-size-${size}`}>
                    <StandardComp
                        style={{ cursor: "unset", "padding": "0px", "overflow": hidden ? "hidden":'', "position": "relative"}}
                        content={content || children}
                    />
                </div>
            </div>
        )
    }
})

export const ModalTitle = ({ title, hasXmark, dismissable }) => {
    return (
        <HorizontalLayout className="modal-padding">
            <div className={"modal-title"}>
                {title}
            </div>
            { hasXmark && <div role="modal-xmark" className="modal-xmark" onClick={dismissable}>
                {icon("x", 16)}
            </div> }
        </HorizontalLayout>
    )
}

export const ModalBody = ({ content, style, children }) => {
    return (
        <>
            <div style={style} className={"modal-body"}>
                {content}{children}
            </div>
        </>
    )
}

export const ModalFooter = ({ content ,children,style}) => {
    return (
        <>
            <HorizontalLayout style={style} className={"modal-footer"}>
                {content}{children}
            </HorizontalLayout>
        </>
    )
}

